console.log("SCRIPT PAGEVIEW TRACKING LOADED");

document.addEventListener("DOMContentLoaded", function () {
    trackPageView();
});

// Función para detectar bots
function isBot() {
    const userAgent = navigator.userAgent.toLowerCase();

    // Lista de patrones conocidos de bots
    const botPatterns = [
        'bot', 'crawl', 'spider', 'slurp', 'mediapartners', 'adsbot', 'bingbot',
        'googlebot', 'yahoo', 'baiduspider', 'yandex', 'duckduckbot', 'facebookexternalhit',
        'facebot', 'ia_archiver', 'msnbot', 'pingdom', 'monitoring', 'prerender',
        'phantom', 'headless', 'selenium', 'puppeteer', 'chrome-lighthouse',
        'gtmetrix', 'ahrefsbot', 'semrushbot', 'dotbot', 'rogerbot', 'twitterbot',
        'whatsapp', 'telegram', 'slackbot', 'discordbot', 'applebot', 'petalbot',
        'bytespider', 'bytedance', 'spider-feedback', 'daum', 'sogou', 'exabot'
    ];

    // Verificar user agent contra patrones de bots
    if (botPatterns.some(pattern => userAgent.includes(pattern))) {
        console.log('Page View Tracking: Bot detectado por user agent:', userAgent);
        return true;
    }

    // Verificar propiedades específicas de navegadores reales
    if (typeof navigator.webdriver !== 'undefined' && navigator.webdriver) {
        console.log('Page View Tracking: Bot detectado por webdriver');
        return true;
    }

    // Verificar si faltan características típicas de navegadores reales
    if (!navigator.languages || navigator.languages.length === 0) {
        console.log('Page View Tracking: Bot detectado por falta de idiomas');
        return true;
    }

    // Verificar si faltan plugins (navegadores modernos tienen al menos algunos)
    if (navigator.plugins && navigator.plugins.length === 0 && !navigator.userAgent.includes('Mobile')) {
        console.log('Page View Tracking: Posible bot detectado por falta de plugins');
        return true;
    }

    // Verificar dimensiones de pantalla sospechosas
    if (screen.width === 0 || screen.height === 0) {
        console.log('Page View Tracking: Bot detectado por dimensiones de pantalla inválidas');
        return true;
    }

    return false;
}

// Función para enviar el evento de página vista
async function trackPageView() {
    try {
        // PASO 1: Detectar bots inmediatamente
        if (isBot()) {
            console.warn('Page View Tracking: Evento bloqueado - Bot detectado');
            return;
        }

        // Verificar que estamos en una página de producto
        if (typeof Shopify === 'undefined' || typeof Shopify.country === 'undefined') {
            console.warn('Page View Tracking: Shopify no está disponible');
            return;
        }

        // Obtener el marketplace actual desde Shopify.country
        const marketplace = (Shopify.country || 'es').toLowerCase();

        // Obtener el ID del producto desde la URL
        // Ejemplo: https://www.zacaris.com/products/botines-timberland-stone-street-6-inch-la-1000124234
        // Ejemplo: https://www.zacaris.com/products/cualquier-cosa-56339
        // El product_id siempre es el número después del último guión medio "-"
        const currentUrl = window.location.href;
        const urlMatch = currentUrl.match(/-(\d+)$/);

        if (!urlMatch || !urlMatch[1]) {
            console.warn('Page View Tracking: No se encontró el ID del producto en la URL');
            return;
        }

        const productsId = urlMatch[1];

        console.log(`Page View Tracking: Producto detectado - ID: ${productsId}, marketplace: ${marketplace}`);

        console.log('Page View Tracking: Interacción humana verificada');

        // Preparar payload para el webhook
        const payload = {
            products_id: productsId,
            site: 'zacaris',
            marketplace: marketplace
        };

        const endpoint = 'https://api.zacaris.com/priceshape/webhooks/pageView';

        console.log('Page View Tracking: Enviando datos al webhook:', payload);

        // Enviar datos al webhook
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload),
            keepalive: true
        }).catch(networkError => {
            console.error('Page View Tracking: Error de red:', networkError);
            return null;
        });

        if (!response) {
            console.error('Page View Tracking: No se pudo enviar datos');
            return;
        }

        if (response.ok) {
            console.log('Page View Tracking: Datos enviados exitosamente');
        } else {
            console.error(`Page View Tracking: Error en respuesta del webhook: ${response.status} ${response.statusText}`);
        }

    } catch (error) {
        console.error('Page View Tracking: Error global:', error);
    }
}
